import { AuthenticationResult } from "@azure/msal-browser";
import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { IUser, IWarehouse } from "model";
import { IAuthenticate } from "model/Identity/IAuthenticate";
import { IdentityActions } from "redux/actions";
interface IIdentityState extends IBaseReducerState {
  authenticate?: IAuthenticate;
  microsoftAzureAuthenticate?: AuthenticationResult;
  deviceId?: string;
  currentWarehouse?: IWarehouse;
  currentUser?: IUser;
}

const initialState: IIdentityState = {
  action: IdentityActions.prefix,
  prefix: IdentityActions.prefix,
};

const authenticate = (
  state: IIdentityState,
  action: PayloadAction<IAuthenticate>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.authenticate = action.payload;
    if (!state.currentWarehouse) {
      state.currentWarehouse = action.payload.warehouses[0];
    }
  });
const pingAuthenticate = (
  state: IIdentityState,
  action: PayloadAction<IAuthenticate>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.authenticate = action.payload;
    if (!state.currentWarehouse) {
      state.currentWarehouse = action.payload.warehouses[0];
    }
  });
const microsoftAzureAuthenticate = (
  state: IIdentityState,
  action: PayloadAction<AuthenticationResult>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.microsoftAzureAuthenticate = action.payload;
  });

const setCurrentWarehouse = (
  state: IIdentityState,
  action: PayloadAction<IWarehouse>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.currentWarehouse = action.payload;
  });
const setCurrentUser = (state: IIdentityState, action: PayloadAction<IUser>) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.currentUser = action.payload;
  });
const logout = (state: IIdentityState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.authenticate = undefined;
    state.currentWarehouse = undefined;
    state.currentUser = undefined;
  });

const setDeviceId = (state: IIdentityState, action: PayloadAction<string>) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.deviceId = action.payload;
  });

const clearAction = (state: IIdentityState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = IdentityActions.prefix + "/";
  });

const GeneralReducer = ReduxHelper.createHandleReducer(
  initialState,
  (builder) => {
    builder
      .addCase(IdentityActions.authenticate.success, authenticate)
      .addCase(
        IdentityActions.pingAuthenticate.success,
        pingAuthenticate
      )
      .addCase(
        IdentityActions.microsoftAzureAuthenticate.request,
        microsoftAzureAuthenticate
      )
      .addCase(IdentityActions.setCurrentWarehouse.request, setCurrentWarehouse)
      .addCase(IdentityActions.getCurrentUser.success, setCurrentUser)
      .addCase(IdentityActions.logout.request, logout)
      .addCase(IdentityActions.setDeviceId.request, setDeviceId)
      .addCase(IdentityActions.clearAction.request, clearAction);
  }
);

export default GeneralReducer;
